import { logger } from '@tunasong/models'
import type { EventDuration } from '../note/index.js'
import { isDottedEasyScoreDuration } from './duration.js'
import type { EasyScoreDuration } from './duration.js'

/** The undotted token, or null when there is none. */
const undottedToken = (num: string | number, eventDuration: string | undefined): EasyScoreDuration | null => {
  if ((eventDuration === 'm' || eventDuration === 'n') && num === '1') {
    return 'w'
  }
  if (eventDuration === 'n' && (num === '8' || num === '16')) {
    return num
  }
  if (eventDuration === 'n' && num === '2') {
    return 'h'
  }
  if (eventDuration === 'n' && num === '4') {
    return 'q'
  }
  return null
}

/** Convert duration from NoteEvent duration to EasyScoreDuration */
export const convertDuration = (duration: EventDuration): EasyScoreDuration => {
  /** First parse the initial number */
  if (typeof duration === 'number') {
    throw new Error(`Cannot convert clock time durations to EasyScore`)
  }

  const [, num = 1, eventDuration, dotted] = /^(\d*)(.)(.)?$/.exec(duration) ?? []

  const token = undottedToken(num, eventDuration)
  if (!token) {
    logger.warn(`Unable to convert ${duration} to EasyScore`)
    return eventDuration as EasyScoreDuration
  }
  if (!dotted) {
    return token
  }
  /** Keep the dot. Dropping it counts and draws a dotted quarter as a quarter, a bar short by an eighth. */
  const dottedToken = `${token}${dotted}`
  if (isDottedEasyScoreDuration(dottedToken)) {
    return dottedToken
  }
  logger.warn(`Unable to convert ${duration} to EasyScore`)
  return token
}
